import React from 'react'
import './Services.css'
import Card from '../Card/Card'
import {motion} from 'framer-motion'
import HeartEmoji from "../../img/heartemoji.png"
import Glasses from "../../img/glasses.png"
import Humble from "../../img/humble.png"
import Resume from './resume.docx'
import { themeContext } from '../../Context';
import { useContext } from "react";
const Services = () => {
const transition={duration: 1,type: 'spring'}
  const theme =useContext(themeContext)
  const darkMode=theme.state.darkMode
  return (
   <div className="services" id='Services'>
    {/* left side */}
    <div className="awesome">
    <span style={{color:darkMode?'white':''}}>My Awesome</span>
    <span>Services</span>
    <span>Developed a Sales field mobile application using Flutter<br />
    during my time as an intern at Jobin & Jismi
    </span>
    <a href={Resume} downloadimport resume><button className="button s-button">Download CV</button></a>

    <div className="blur s-blur1" style={{background: "#ABF1FF94"}}></div>
    </div>
    {/* right side */}
    <div className="cards">
      <motion.div
       whileInView={{left:'14rem'}}
        initial={{left:'25rem'}}
        transition={transition}
      style={{left:'14rem' }}>
        <Card
          emoji ={HeartEmoji}
          heading ={'Design'}
          detail = {"Html, Css, React"}
        />
      </motion.div>

     
       {/* second card */}
      <motion.div 
      whileInView={{top:'12rem',left:'-4rem'}}
      initial={{left:'-10rem'}}
      transition={transition}
      style={{top: '12rem', left:'-4rem' }}>
        <Card
          emoji ={Glasses}
          heading ={'Developer'}
          detail = {"Flutter, Firebase, Dart "}
        />
      </motion.div>
        
        {/* 3rd */}

      <motion.div 
      whileInView={{top:'19rem',left:'12rem'}}
      initial={{left:'30rem'}}
      transition={transition}
      style={{top: '19rem', left:'12rem' }}>
        <Card
          emoji ={Humble}
          heading ={'UI/UX'}
          detail = {"Html, Css, Javascript, React"}
        />
      </motion.div>
<div className="blur s-blur2" style={{background: 'var(--purple)'}}></div>

    </div>
   </div>
  )
}

export default Services